import { ComponentType } from 'react';
import { useCurrentTeams, useCurrentUser } from '../libs/services/s4p';

export const WithUser = (Component: ComponentType<any>) =>
  function _(props: any) {
    const organizations = useCurrentTeams();

    if (localStorage.getItem('SPA-Current-Team') === null && organizations.length > 0) {
      const firstTeam = organizations.sort((a, b) =>
        a.organizationName.localeCompare(b.organizationName),
      )[0];
      localStorage.setItem('SPA-Current-Team', firstTeam.organizationUri);
    }

    const user = useCurrentUser();
    return <Component user={user} {...props} />;
  };
